import { createTheme } from '@mui/material';
import { baseOptions } from './base/CreateOptions';
import { baseComponents } from './base/CreateComponents';
import { lightPalette } from './light/CreatePalette';
import { darkPalette } from './dark/CreatePalette';

export const lightTheme = createTheme({
    ...baseOptions,
    palette: lightPalette,
    components: baseComponents,
});

export const darkTheme = createTheme({
    ...baseOptions,
    palette: darkPalette,
    components: baseComponents,
});
